import { AxiosResponse } from 'axios';
import HttpStatus from 'model/enums/httpStatus';
import { ShareholderDocumentsToGetAll } from 'model/shareholder-documents.model';
import { markError } from 'reducer/application/error/actions';
import { getShareholderDocumentsError, getShareholderDocumentsRequest, getShareholderDocumentsSuccess } from 'reducer/shareholder/get-shareholder-documents/actions';
import { GetShareholderDocumentsActionTypes } from 'reducer/shareholder/get-shareholder-documents/types';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import shareholderDocumentsApi from 'services/api/shareholder-documents-api';
import { Page } from 'services/page';
import { ErrorUtils } from 'shared/error/error-utils';

function* handleGetAllShareholderDocumentsProfile(action: ReturnType<typeof getShareholderDocumentsRequest>) {
    try {
        const result: AxiosResponse<Page<ShareholderDocumentsToGetAll>> = yield call(shareholderDocumentsApi.getDocuments, action.payload);
        if (result.status !== HttpStatus.OK) {
            const mapped = ErrorUtils.mapGiroIdhApiError(result);
            yield put(markError(mapped));
            yield put(getShareholderDocumentsError(mapped));
            return;
        }
        yield put(getShareholderDocumentsSuccess(result.data));
    } catch (error) {
        const mapped = ErrorUtils.mapLocalError(error);
        yield put(markError(mapped));
        yield put(getShareholderDocumentsError(mapped));
    }
}

function* watchGetSharheolderDocumentsRequest() {
    yield takeEvery(GetShareholderDocumentsActionTypes.GET_SHAREHOLDER_DOCUMENTS_REQUEST, handleGetAllShareholderDocumentsProfile);
}

function* getShareholderDocumentsSagas() {
    yield all([fork(watchGetSharheolderDocumentsRequest)]);
}

export default getShareholderDocumentsSagas;
